import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { useTrackingStore } from "../store";
import type { MapControllerProps } from "../types/components.types";

export const MapController = ({ mapRef }: MapControllerProps) => {
	const map = useMap();
	const { selectedVehicleId, setSelectedVehicleId } = useTrackingStore();

	useEffect(() => {
		mapRef.current = map;
	}, [map, mapRef]);

	useEffect(() => {
		const handleMapClick = () => {
			if (selectedVehicleId !== null) {
				setSelectedVehicleId(null);
			}
		};

		map.on("click", handleMapClick);

		return () => {
			map.off("click", handleMapClick);
		};
	}, [map, selectedVehicleId, setSelectedVehicleId]);

	return null;
};
